import Layout from '@/components/layout'
import { Button } from '@/components/ui/button'
import { SignedIn, SignedOut } from '@clerk/clerk-react'
import { Link } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthProvider'
import { Lock } from 'lucide-react'

export default function LearningToolkit() {
  const { currentOrg, appUserLoaded } = useAuth()
  const isEligible = appUserLoaded && !!currentOrg

  return (
    <Layout>
      <div className="w-full max-w-4xl p-6">
        <SignedIn>
          <div className="flex flex-col gap-6">
            <div>
              <h1 className="text-2xl font-bold">Learning &amp; Toolkit</h1>
              <p className="text-sm text-muted-foreground">Available for paid plans only.</p>
              <div className="mt-2">
                <Link to="/paddle-checkout">
                  <Button variant="outline" size="sm" disabled={!appUserLoaded}>
                    Purchase a plan now
                  </Button>
                </Link>
              </div>
            </div>

            <div className="flex flex-col gap-3">
              {isEligible ? (
                <Link to="/learning-toolkit/debate-elements-course">
                  <Button variant="outline" className="w-full justify-start">
                    Debate Elements Course
                  </Button>
                </Link>
              ) : (
                <Button
                  variant="outline"
                  className="w-full justify-start"
                  disabled
                  title={!appUserLoaded ? 'Loading account…' : 'Paid plan required'}
                >
                  <span className="flex items-center gap-2">
                    <Lock size={16} /> Debate Elements Course
                  </span>
                </Button>
              )}

              {isEligible ? (
                <Link to="/learning-toolkit/speech-toolkit">
                  <Button variant="outline" className="w-full justify-start">
                    Speech Toolkit
                  </Button>
                </Link>
              ) : (
                <Button
                  variant="outline"
                  className="w-full justify-start"
                  disabled
                  title={!appUserLoaded ? 'Loading account…' : 'Paid plan required'}
                >
                  <span className="flex items-center gap-2">
                    <Lock size={16} /> Speech Toolkit
                  </span>
                </Button>
              )}

              {isEligible ? (
                <Link to="/create-debate">
                  <Button variant="marketing" className="w-full justify-start">
                    Create Debate
                  </Button>
                </Link>
              ) : (
                <Button
                  variant="marketing"
                  className="w-full justify-start"
                  disabled
                  title={!appUserLoaded ? 'Loading account…' : 'Paid plan required'}
                >
                  <span className="flex items-center gap-2">
                    <Lock size={16} /> Create Debate
                  </span>
                </Button>
              )}
            </div>
          </div>
        </SignedIn>

        <SignedOut>
          <div className="flex flex-col gap-3">
            <h1 className="text-2xl font-bold">Learning &amp; Toolkit</h1>
            <p className="text-sm text-muted-foreground">Please sign in to access this page.</p>
            <a href="/sign-in">
              <Button variant="outline">Sign in</Button>
            </a>
          </div>
        </SignedOut>
      </div>
    </Layout>
  )
}

